import { EventBus } from "../../contexts";
import { logger, LOGS } from "../../utils";
import { CO2Saved } from "./types/co2";

export class CO2Manager {
    // #region Properties

    private eventBus: EventBus;

    // #endregion Properties

    constructor(eventBus: EventBus) {
        logger.info(LOGS.CO2Manager, "()");

        this.eventBus = eventBus;
    }

    // #region Initialisation and cleanup

    /**
     * @method cleanup
     * Cleans up all resources and stops all active processes for the CO2Manager
     * ═══════════════════════════════════════════════════════════════════════════
     * @input {void}
     * @output {Promise<void>}
     * @public
     */
    public async _cleanup(): Promise<void> {
        logger.info(
            LOGS.CO2Manager,
            "CO2Manager.cleanup() - Starting cleanup process",
        );

        // Phase 1: Stop all active processes and timers
        try {
            logger.info(
                LOGS.CO2Manager,
                "  Phase 1: Stopping active processes",
            );
        } catch (error) {
            logger.error(
                LOGS.CO2Manager,
                `CO2Manager.cleanup() - Error in Phase 1: ${error}`,
            );
        }

        // Phase 2: Clear internal state and caches
        try {
            logger.info(LOGS.CO2Manager, "  Phase 2: Clearing internal state");
        } catch (error) {
            logger.error(
                LOGS.CO2Manager,
                `CO2Manager.cleanup() - Error in Phase 2: ${error}`,
            );
        }

        logger.info(
            LOGS.CO2Manager,
            "CO2Manager.cleanup() - Cleanup completed successfully",
        );
    }

    // #endregion Initialisation and cleanup

    // #region Public Methods

    /**
     * updateCO2OnDeleteMail
     *
     * TODO [AB#1834] — stub local : le handler legacy Core (CO2_UpdateCO2Saved) était déjà
     * hardcodé à zéro sans accès DB ('!!! CO2 Hard coded !!!'), on supprime donc l'appel
     * réseau sans changement de comportement. Aucun endpoint CO2 n'existe côté Api-Backend —
     * à remplacer par un vrai appel quand le métier CO2 sera implémenté.
     */
    public async updateCO2OnDeleteMail() {
        logger.warn(LOGS.CO2Manager, "log updateCO2OnDeleteMail()");

        const CO2Saved: CO2Saved = {
            totalCO2Saved: 0,
            thisMonthCO2Saved: 0,
            newCO2Saved: 0,
        };

        this.eventBus.emit("co2-updated", CO2Saved);
    }

    // #endregion Public Methods

    // #region Private Methods

    // #endregion Private Methods
}
